import React from "react";
import PropTypes from "prop-types";
import Header from "./Header";
import Body from "./Body";
import Footer from "./Footer";
import { pymSendHeight } from "../utils/handlePym";

const SUBTITLE_TEXT =
  "In the week leading up to the Sept. 1 expiration of the state moratorium on evictions, there was an average of 60 new filings per day. That number skyrocketed on the day the ban lifted, but declined sharply in the days after a new federal moratorium was announced.";

const FOOTNOTE_TEXT =
  "The data represents evictions filed for any reason, not just unpaid rent.";

class Main extends React.Component {
  componentDidMount() {
    // This is intended to fix bug where app is clipped at bottom
    // on initial load.
    pymSendHeight({ timeout: 500 });
    pymSendHeight({ timeout: 1000 });
  }

  componentDidUpdate() {
    // Because our app changes height based on displayed content, we
    // update the iframe height after DOM elements have been updated.
    pymSendHeight();
  }

  render() {
    const { data } = this.props;
    return (
      <div className="container__outer">
        <div className="container__inner">
          <Header
            headline="New eviction filings in Pennsylvania"
            subtitle={SUBTITLE_TEXT}
          />
          <Body data={data} />
          <Footer
            footnote={FOOTNOTE_TEXT}
            byline="Daniel Simmons Ritchie"
            source="CREATE Lab at Carnegie Mellon University / Philadelphia Legal Assistance"
            outlet="Spotlight PA"
            outletUrl="https://www.spotlightpa.org/"
          />
        </div>
      </div>
    );
  }
}

Main.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default Main;
